<template>
  <div :v-show="menu">
    <div class="vx-col w-full mb-base">
      <vs-card title="Menu" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Menu</h4>
          </div>
          <div class="flex items-center">
            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
          </div>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col lg:w-1/4 w-full">
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Module Name *</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.module" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Menu Name *</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.menu" />
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Path *</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.path" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Icon</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.icon" />
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Enable</div>
              <div class="vx-col w-2/3">
                <v-select
                  label="name"
                  :options="enables"
                  style="max-width: 100%;"
                  v-model="menu.enable"
                  :reduce="enable => enable.value"
                ></v-select>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Menu Type *</div>
              <div class="vx-col w-2/3">
                <v-select
                  label="name"
                  :options="menutypes"
                  style="max-width: 100%;"
                  v-model="menu.menu_type"
                  :reduce="menu => menu.value"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
            <div
              class="vx-row mb-3"
              v-if="this.menu.menu_type == 'Child' && this.menu != undefined && this.menu != null"
            >
              <div class="vx-col w-1/3">Parent</div>
              <div class="vx-col w-2/3">
                <v-select
                  label="menu"
                  :options="parents"
                  style="max-width: 100%;"
                  v-model="menu.parent"
                  :reduce="parent => parent.id"
                ></v-select>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">
                Menu Sequence
                <br />
                ({{ menu.sequence }} of {{menu.total}})
              </div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.sequence" />
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      menu: {
        module: "",
        menu: "",
        path: "",
        icon: "",
        sequence: "",
        enable: "",
        menu_type: "",
        parent: ""
      },
      parents: [],
      enables: [
        {
          name: "Yes",
          value: 1
        },
        {
          name: "No",
          value: 0
        }
      ],
      menutypes: [
        {
          name: "Parent",
          value: "Parent"
        },
        {
          name: "Child",
          value: "Child"
        }
      ]
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchData() {
      Promise.all([
        this.$http.post("rolemanagement/menu/parent/dropdown")
      ]).then(
        this.$http.spread(parent => {
          this.parents = parent.data.data;
        })
      );
    },
    back() {
      this.menu.parent = this.menu_type != "child" ? null : this.menu.parent;
      if (
        this.menu.module != "" ||
        this.menu.menu != "" ||
        this.menu.path != "" ||
        this.menu.icon != "" ||
        this.menu.sequence != "" ||
        this.menu.enable != "" ||
        (this.menu.menu_type != "" && this.menu.menu_type != null) ||
        (this.menu.parent != "" && this.menu.parent != null)
      ) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page?",
          text: "Changes you made may not be saved",
          acceptText: "Leave Page",
          accept: () => this.$router.push({ name: "menu" })
        });
      } else {
        this.$router.push({ name: "menu" });
      }
    },
    submitForm() {
      if (
        this.menu.module != "" ||
        this.menu.menu != "" ||
        this.menu.enable != "" ||
        this.menu.menu_type != ""
      ) {
        this.menu.path = `/${this.menu.path}`;
        this.isLoading = true;
        this.$http
          .post("rolemanagement/menu/store", this.menu)
          .then(res => {
            this.isLoading = false;
            this.$router.push({
              name: "menu"
            });
          })
          .catch(err => {
            this.isLoading = false;
            this.$vs.notify({
              color: "danger",
              title: "Error saving",
              iconPack: "feather",
              icon: "icon-x",
              text: err
            });
          });
      } else {
        this.$vs.dialog({
          color: "warning",
          title: "Complete form",
          text: "Complete Form Dude",
          acceptText: "Okay",
          accept: () => {}
        });
      }
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>